module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-standside-1500.7138df80.svg";